import React, {useEffect, useState} from "react";
import {Col, Container, Row} from 'react-bootstrap';
import {useSelector} from "react-redux";
import Toaster from "../../../common/ToastMsg";
import {ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {Navigate} from "react-router-dom";
import UserService from "../../../services/user.service";
import inventoryService from "../../../services/inventory.service";

const InventoryValue = () => {
    const [clients, setClients] = useState([]);
    const [clientsLoading, setClientsLoading] = useState(false);
    const [valueLoading, setValueLoading] = useState(false);

    const [selectedOption, setSelectedOption] = useState("");
    const { user: currentUser } = useSelector((state) => state.auth);

    // State for summary data
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        setClientsLoading(true);
        UserService.getClientList().then(
            (response) => {
                setClients(response.data);
                if (response.data instanceof Array && response.data.length > 0) {
                    setSelectedOption(response.data[0].oid);
                }
                setClientsLoading(false);
            },
            (error) => {
                console.log(error);
                Toaster.error({
                    title: "Failed to load clients !",
                    text: error.message
                }, {
                    position: "top-center",
                    containerId: "search"
                });
                setClientsLoading(false);
            }
        )

    }, []);

    useEffect(() => {
        if (selectedOption) {
            queryValue();
        }
    }, [selectedOption]);
    
    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    const handleSelection = (event) => {
        setSelectedOption(event.target.value);
    };


    const queryValue = () => {
        setSummary(null);
        // Call API for summary data
        setValueLoading(true);
        inventoryService.getInventoryValue(selectedOption)
            .then(response => {
                setSummary(response.data);
                setValueLoading(false);
            })
            .catch(error => {
                console.error("Error fetching value:", error);
                Toaster.error({
                    title: "Failed to load value!",
                    text: error.response?.data?.message || error.message
                }, {
                    position: "top-center",
                    containerId: "inv-value"
                });
                setValueLoading(false);
            });
    };
    
    return (
        <Container fluid>
            <ToastContainer autoClose={3000} containerId={"inv-value"} />
            <Row>
                <Col xs={12} md={8}>
                    <div className="dropdown mb-2">
                        <select
                            value={selectedOption}
                            className="form-select"
                            onChange={handleSelection}
                            disabled={clientsLoading || valueLoading}
                        >
                            {!clients &&
                                <option value="" disabled>
                                    No client found
                                </option>
                            }

                            {clients && clients.map((client, index) => (
                                <option value={client.oid}>
                                    {client.clientName}
                                </option>
                            ))}

                        </select>
                        {(clientsLoading || valueLoading) && (
                            <span className="spinner-border spinner-border-sm text-primary mt-2" role="status"></span>
                        )}
                    </div>
                </Col>
            </Row>

            {/* Summary Section */}
            {valueLoading && (
                <Row className="mb-4">
                    <Col>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Loading inventory value...
                    </Col>
                </Row>
            )}
            {summary && (
                <Row className="mb-4">
                    <Col>
                        <h4>Summary</h4>
                        <div className="p-3 border rounded">
                            <p><strong>Total Inventory Quantity:</strong> {summary.qty}</p>
                            <p><strong>Total Inventory Value:</strong> {summary.total}</p>
                        </div>
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default InventoryValue;
